import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataTablesModule } from 'angular-datatables';

import { SharedDealsRoutingModule } from './shared-deals-routing.module';
import { SharedDealsListComponent } from './shared-deals-list/shared-deals-list.component';

@NgModule({
    declarations: [SharedDealsListComponent],
    imports: [
        CommonModule,
        SharedDealsRoutingModule,
        DataTablesModule,

    ],
    exports: [SharedDealsListComponent]
})
export class SharedDealsModule { }
